import React from "react";
import logo from "./logo.svg";
import { Counter } from "./Pages/Counter/Counter";
import "./App.css";
import { Outlet } from "react-router-dom";
import Navbar from "./Components/Navbar/Navbar";
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate } from "react-router-dom";
import PrivateRoutes from "./Components/PrivateRoutes/PrivateRoutes";
import { RoutesWrapper } from "./Components/RoutesWrapper/RoutesWrapper";
import RecordForm from "./Pages/RecordForm/RecordForm";
import SignIn from "./Pages/SignIn/SignIn";
import NotFound from "./Pages/NotFound/NotFound";
import PaymentStatus from "./Pages/PaymentStatus/PaymentStatus";
import RecordHistory from "./Pages/RecordHistory/RecordHistory";
function App() {
	return (
		<div className="App">
			{/* <Navbar>
				<Outlet />
			</Navbar> */}
			<Router>
				<RoutesWrapper>
					<Route element={<PrivateRoutes />}>
						<Route path="/" element={<Navigate to="/dashboard" replace />} />
						<Route path="dashboard" element={<RecordForm />} />
						<Route path="payment-status" element={<PaymentStatus />} />
						<Route path="record-history" element={<RecordHistory />} />
					</Route>

					<Route path="/sign-in" element={<SignIn />} />
					{/* <Route path="/sign-up" element={<SignUpPage />} /> */}
					<Route path="*" element={<NotFound />} />
				</RoutesWrapper>
			</Router>
		</div>
	);
}

export default App;
